import { render, staticRenderFns } from "./IconFontSelector.vue?vue&type=template&id=90538afa"
import script from "./IconFontSelector.vue?vue&type=script&lang=js"
export * from "./IconFontSelector.vue?vue&type=script&lang=js"
import style0 from "./IconFontSelector.vue?vue&type=style&index=0&id=90538afa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports